import { useQuery } from "@tanstack/react-query";
import { createContext, useContext } from "react";
import useAPI from "../api/hooks/useAPI";
import { inventoryBootstrapKeys } from "../api/queryKeys";

export const InventoryBootstrapContext = createContext({
  isLoading: true,
  isSuccess: false,
  labels: [],
  tags: [],
  favorites: [],
  inventoryViews: [],
});

export const InventoryBootstrapProvider = ({ children }) => {
  const { getInventoryBootstrap } = useAPI();

  const { data, isLoading, isSuccess, isError } = useQuery({
    queryKey: inventoryBootstrapKeys.all,
    queryFn: getInventoryBootstrap,
    select: (response) => response.data,
  });

  const labels = data?.labels?.filter((label) => !label.is_deleted) || [];
  const tags = data?.tags?.filter((tag) => !tag.is_deleted) || [];

  const value = {
    isLoading,
    isSuccess,
    isError,
    labels,
    tags,
    favorites: data?.favorites || [],
    inventoryViews: data?.inventory_views || [],
  };

  return (
    <InventoryBootstrapContext.Provider value={value}>
      {children}
    </InventoryBootstrapContext.Provider>
  );
};

export const useInventoryBootstrap = () => {
  return useContext(InventoryBootstrapContext);
};
